/* DreamPrices – Prisskyltar & etiketter (Claude 2026-08-14)
   Data hämtas från Shopify via två Liquid-vyer:
     /search?q=...&type=product&view=dpetiketter
     /collections/HANDLE?view=dpetiketter&page=N
   Anledningen är att EAN (variant.barcode) bara är läsbar i Liquid. */

(function(){
var D = window.DPE_DATA || { shopName:'DreamPrices', logo:'', tagline:'', routes:{search:'/search', root:'/'} };
var VIEW = 'dpetiketter';
var JSBARCODE = 'https://cdnjs.cloudflare.com/ajax/libs/jsbarcode/3.11.6/JsBarcode.all.min.js';

var LIST = [];   /* valda rader */
var HITS = [];   /* senaste sökträffar */

function el(id){ return document.getElementById(id); }
function esc(v){
  return String(v == null ? '' : v)
    .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
}
function kr(n){
  return Number(n || 0).toLocaleString('sv-SE', {minimumFractionDigits:0, maximumFractionDigits:0}) + ' kr';
}
function fullName(it){
  return it.single || !it.variant || it.variant === 'Default Title' ? it.title : it.title + ' – ' + it.variant;
}
function keyOf(it){ return String(it.id); }

/* Säljpunkter: i första hand listan från metafältet Höjdpunkter / Utdrag /
   beskrivningen, annars USP-raden uppdelad på · | • ; */
function normUsp(it){
  var arr = (it.usp || []).map(function(s){ return String(s || '').trim(); }).filter(Boolean);
  if(!arr.length && it.uspLine){
    arr = String(it.uspLine).split(/[·|•;]+/).map(function(s){ return s.trim(); }).filter(Boolean);
  }
  return arr.slice(0, 4);
}

/* ---- hämtning ---------------------------------------------------------- */
function getJSON(url){
  return fetch(url, { headers: { 'Accept': 'text/html' } }).then(function(r){
    if(!r.ok) throw new Error('HTTP ' + r.status);
    return r.text();
  }).then(function(t){
    var a = t.indexOf('{'), b = t.lastIndexOf('}');
    if(a < 0 || b < 0) throw new Error('Ogiltigt svar');
    return JSON.parse(t.slice(a, b + 1));
  });
}

function search(){
  var q = String(el('dpeSearch').value || '').trim();
  var box = el('dpeHits');
  if(!q){ box.innerHTML = ''; return; }
  box.innerHTML = '<div class="dpe-empty">Söker…</div>';
  var url = (D.routes.search || '/search') + '?q=' + encodeURIComponent(q) + '&type=product&view=' + VIEW;
  getJSON(url).then(function(data){
    HITS = data.items || [];
    renderHits(data);
  }).catch(function(e){
    box.innerHTML = '<div class="dpe-empty dpe-warn">Kunde inte söka: ' + esc(e.message) + '</div>';
  });
}

function renderHits(data){
  var box = el('dpeHits');
  if(!HITS.length){ box.innerHTML = '<div class="dpe-empty">Inga träffar.</div>'; return; }
  var html = '<div class="dpe-hits">';
  HITS.forEach(function(it, i){
    var meta = [];
    if(it.sku) meta.push('Art: ' + esc(it.sku));
    meta.push(it.ean ? 'EAN: ' + esc(it.ean) : '<span class="dpe-warn">EAN saknas</span>');
    if(it.vendor) meta.push(esc(it.vendor));
    html += '<div class="dpe-hit" onclick="DPE.add(' + i + ')">' +
      (it.image ? '<img src="' + esc(it.image) + '" alt="">' : '<img alt="">') +
      '<div class="dpe-hit-main"><div class="dpe-hit-name">' + esc(fullName(it)) + '</div>' +
      '<div class="dpe-hit-meta">' + meta.join(' · ') + '</div></div>' +
      '<div class="dpe-hit-price">' + kr(it.price) + '</div></div>';
  });
  html += '</div>';
  if(data.more) html += '<div class="dpe-note">Fler träffar finns – förfina sökningen om du inte hittar rätt.</div>';
  box.innerHTML = html;
}

function loadCollection(){
  var handle = el('dpeCollection').value;
  if(!handle){ alert('Välj en kollektion först.'); return; }
  var status = el('dpeCollStatus');
  var added = 0;
  status.textContent = 'Hämtar…';

  function page(n){
    var url = (D.routes.root || '/') + 'collections/' + handle + '?view=' + VIEW + '&page=' + n;
    return getJSON(url).then(function(data){
      (data.items || []).forEach(function(it){ if(push(it)) added++; });
      status.textContent = 'Hämtar… ' + added + ' rader';
      if(data.more && n < 30) return page(n + 1);
    });
  }

  page(1).then(function(){
    status.textContent = added + ' rader tillagda.';
    renderList();
  }).catch(function(e){
    status.innerHTML = '<span class="dpe-warn">Fel: ' + esc(e.message) + '</span>';
  });
}

/* ---- lista ------------------------------------------------------------- */
function push(it){
  var k = keyOf(it);
  for(var i = 0; i < LIST.length; i++){ if(LIST[i].key === k) return false; }
  LIST.push({
    key: k, title: it.title, variant: it.variant, single: it.single, vendor: it.vendor,
    sku: it.sku || '', ean: it.ean || '', price: it.price, compare: it.compare,
    image: it.image, qty: 1, usp: normUsp(it),
    warranty: (it.warranty && it.warranty[0]) || D.warrantyDefault || ''
  });
  return true;
}
function add(i){
  var it = HITS[i];
  if(!it) return;
  if(!push(it)) { alert('Artikeln finns redan i listan.'); return; }
  renderList();
}
function remove(k){
  LIST = LIST.filter(function(r){ return r.key !== k; });
  renderList();
}
function setQty(k, v){
  var n = parseInt(v, 10) || 1;
  if(n < 1) n = 1;
  LIST.forEach(function(r){ if(r.key === k) r.qty = n; });
  updateCount();
}
function setUsp(k, text){
  var rows = String(text || '').split('\n').map(function(s){ return s.trim(); }).filter(Boolean).slice(0, 4);
  LIST.forEach(function(r){ if(r.key === k) r.usp = rows; });
  var b = el('dpeUspBtn-' + k);
  if(b) b.textContent = 'Säljpunkter (' + rows.length + ')';
}
function setWarranty(k, v){
  var t = String(v || '').trim().slice(0, 60);
  LIST.forEach(function(r){ if(r.key === k) r.warranty = t; });
}
function toggleUsp(k){
  var row = el('dpeUspRow-' + k);
  if(!row) return;
  row.style.display = (row.style.display === 'none' || !row.style.display) ? 'table-row' : 'none';
  if(row.style.display === 'table-row'){ var ta = el('dpeUspTa-' + k); if(ta) ta.focus(); }
}

function setAllQty(){
  if(!LIST.length){ alert('Listan är tom.'); return; }
  var v = window.prompt('Antal etiketter per artikel:', '1');
  if(v === null) return;
  var n = parseInt(v, 10) || 1;
  if(n < 1) n = 1;
  LIST.forEach(function(r){ r.qty = n; });
  renderList();
}
function clearList(){
  if(!LIST.length) return;
  if(!window.confirm('Töm hela utskriftslistan?')) return;
  LIST = [];
  renderList();
}

function renderList(){
  var box = el('dpeList');
  if(!LIST.length){
    box.innerHTML = '<div class="dpe-empty">Inga artiklar valda ännu. Sök fram artiklar ovan eller hämta en kollektion.</div>';
    updateCount();
    return;
  }
  var html = '<table class="dpe-list"><thead><tr>' +
    '<th>Artikel</th><th>Art.nr</th><th>EAN</th><th class="num">Pris</th><th class="num">Antal</th><th></th>' +
    '</tr></thead><tbody>';
  LIST.forEach(function(r){
    var n = (r.usp || []).length;
    html += '<tr>' +
      '<td>' + esc(fullName(r)) +
        '<div style="margin-top:4px;"><button type="button" class="dpe-btn--mini" id="dpeUspBtn-' + r.key + '" onclick="DPE.toggleUsp(\'' + r.key + '\')">Säljpunkter (' + n + ')</button></div>' +
      '</td>' +
      '<td>' + (r.sku ? esc(r.sku) : '<span class="dpe-warn">–</span>') + '</td>' +
      '<td>' + (r.ean ? esc(r.ean) : '<span class="dpe-warn">saknas</span>') + '</td>' +
      '<td class="num">' + kr(r.price) + (r.compare ? '<br><span style="font-size:11px;color:#6b7a6e;text-decoration:line-through">' + kr(r.compare) + '</span>' : '') + '</td>' +
      '<td class="num"><input type="number" min="1" max="200" value="' + r.qty + '" onchange="DPE.setQty(\'' + r.key + '\', this.value)"></td>' +
      '<td class="num"><button type="button" class="dpe-btn--mini" onclick="DPE.remove(\'' + r.key + '\')">Ta bort</button></td>' +
      '</tr>' +
      '<tr class="dpe-usp-row" id="dpeUspRow-' + r.key + '" style="display:none;"><td colspan="6">' +
        '<div class="dpe-usp-lbl">Säljpunkter på A6-skylten – en per rad, max fyra. Skriv prestanda: spänning, moment, kapacitet, vikt.</div>' +
        '<textarea class="dpe-usp-ta" id="dpeUspTa-' + r.key + '" rows="4" oninput="DPE.setUsp(\'' + r.key + '\', this.value)">' + esc((r.usp || []).join('\n')) + '</textarea>' +
        '<div class="dpe-usp-lbl" style="margin-top:9px;">Garantitext (visas som grön knapp på skylten)</div>' +
        '<input type="text" class="dpe-usp-ta" maxlength="60" placeholder="t.ex. 3 års garanti vid registrering" value="' + esc(r.warranty || '') + '" oninput="DPE.setWarranty(\'' + r.key + '\', this.value)">' +
      '</td></tr>';
  });
  html += '</tbody></table>';
  box.innerHTML = html;
  updateCount();
}

function updateCount(){
  var rows = LIST.length, labels = 0, noEan = 0;
  LIST.forEach(function(r){ labels += r.qty; if(!r.ean) noEan++; });
  var t = rows ? (rows + ' artiklar · ' + labels + ' etiketter') : 'Inga artiklar valda.';
  if(noEan) t += ' · ' + noEan + ' utan EAN (streckkoden görs då på artikelnumret)';
  el('dpeCount').textContent = t;
}

/* ---- streckkod --------------------------------------------------------- */
function bcSpec(r){
  var s = String(r.ean || '').replace(/[\s-]/g, '');
  if(/^\d{13}$/.test(s)) return { v: s, f: 'EAN13', label: s };
  if(/^\d{12}$/.test(s)) return { v: s, f: 'UPC', label: s };
  if(/^\d{8}$/.test(s))  return { v: s, f: 'EAN8', label: s };
  if(s) return { v: s, f: 'CODE128', label: s };
  var sku = String(r.sku || '').trim();
  if(sku) return { v: sku, f: 'CODE128', label: sku };
  return null;
}

/* ---- utskrift ---------------------------------------------------------- */
function expand(){
  var out = [];
  LIST.forEach(function(r){ for(var i = 0; i < r.qty; i++) out.push(r); });
  return out;
}

function printSheet(kind){
  if(!LIST.length){ alert('Listan är tom.'); return; }
  var offX = parseFloat(el('dpeOffX').value) || 0;
  var offY = parseFloat(el('dpeOffY').value) || 0;
  var items = expand();
  var html = (kind === 'a6') ? buildA6(items, offX, offY) : buildSmall(items, offX, offY);

  var w = window.open('', '_blank');
  if(!w){ alert('Din webbläsare blockerade fönstret. Tillåt popups för denna sida.'); return; }
  w.document.open();
  w.document.write(html);
  w.document.close();
  w.focus();
}

function barcodeRunner(height, width){
  return '<script src="' + JSBARCODE + '"><\/script>' +
  '<script>' +
  'window.addEventListener("load", function(){' +
  '  var els = document.querySelectorAll("svg.bc");' +
  '  for(var i=0;i<els.length;i++){' +
  '    var e = els[i], v = e.getAttribute("data-v"), f = e.getAttribute("data-f");' +
  '    try { JsBarcode(e, v, {format:f, displayValue:false, margin:0, height:' + height + ', width:' + width + '}); }' +
  '    catch(err){ try { JsBarcode(e, v, {format:"CODE128", displayValue:false, margin:0, height:' + height + ', width:' + (width * 0.8) + '}); } catch(e2){ e.style.display="none"; } }' +
  '  }' +
  '  setTimeout(function(){ window.print(); }, 600);' +
  '});' +
  '<\/script>';
}

function buildA6(items, offX, offY){
  var C = (D.colors || {});
  var brand  = C.brand  || '#1e88e5';
  var accent = C.accent || '#00c18f';
  var soft   = C.soft   || '#f9f9f9';
  var sale   = C.sale   || '#ff7043';
  var ink    = C.ink    || '#212121';
  var gradA  = C.gradA  || '#0d6efd';
  var gradB  = C.gradB  || '#20c997';
  var saleLabel = D.saleLabel || 'KAMPANJ';

  var cells = items.map(function(r){
    var bc = bcSpec(r);
    var onSale = !!r.compare;
    return '<div class="lbl' + (onSale ? ' is-sale' : '') + '">' +
      (onSale ? '<div class="flag">' + esc(saleLabel) + '</div>' : '') +
      '<div class="top">' +
        (D.logo ? '<span class="logochip"><img src="' + esc(D.logo) + '" alt=""></span>' : '') +
        '<div class="brandbox"><div class="bn">' + esc(D.shopName) + '</div>' +
        (D.tagline ? '<div class="bt">' + esc(D.tagline) + '</div>' : '') + '</div>' +
      '</div>' +
      '<div class="bar"></div>' +
      '<div class="mid">' +
        (r.vendor ? '<span class="chip">' + esc(r.vendor) + '</span>' : '') +
        '<div class="name">' + esc(fullName(r)) + '</div>' +
        ((r.usp && r.usp.length) ? '<ul class="usp">' + r.usp.map(function(u){ return '<li>' + esc(u) + '</li>'; }).join('') + '</ul>' : '') +
        (r.warranty ? '<div class="warr"><svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l7 3v5c0 4.4-3 8.3-7 10-4-1.7-7-5.6-7-10V6z"></path><path d="M9 12l2 2 4-4"></path></svg><span>' + esc(r.warranty) + '</span></div>' : '') +
      '</div>' +
      '<div class="pricebox">' +
        (onSale ? '<div class="ord">Ord. pris <s>' + kr(r.compare) + '</s></div>' : '') +
        '<div class="price">' + kr(r.price) + '</div>' +
        '<div class="vat">inkl. moms</div>' +
      '</div>' +
      '<div class="bot">' +
        '<div class="ids">' + (r.sku ? '<div>Art.nr <b>' + esc(r.sku) + '</b></div>' : '') +
          (r.ean ? '<div>EAN ' + esc(r.ean) + '</div>' : '') + '</div>' +
        (bc ? '<svg class="bc" data-v="' + esc(bc.v) + '" data-f="' + bc.f + '"></svg>' : '') +
      '</div>' +
    '</div>';
  }).join('');

  return '<!DOCTYPE html><html lang="sv"><head><meta charset="UTF-8"><title>Prisskyltar A6</title><style>' +
  '@import url("https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700&family=DM+Sans:wght@400;500;600;700&display=swap");' +
  '@page{size:A4 portrait;margin:0;}' +
  '*{box-sizing:border-box;margin:0;padding:0;}' +
  'body{font-family:"DM Sans",sans-serif;color:' + ink + ';-webkit-print-color-adjust:exact;print-color-adjust:exact;}' +
  '.sheet{display:grid;grid-template-columns:105mm 105mm;grid-auto-rows:148.5mm;width:210mm;padding-left:' + offX + 'mm;padding-top:' + offY + 'mm;}' +
  '.lbl{position:relative;width:105mm;height:148.5mm;display:flex;flex-direction:column;background:#fff;overflow:hidden;border:0.8mm solid ' + brand + ';}' +
  '.is-sale{border-color:' + sale + ';}' +
  '.flag{position:absolute;top:0;right:0;background:' + sale + ';color:#fff;font-size:8.5pt;font-weight:700;letter-spacing:0.16em;padding:2mm 5mm;border-bottom-left-radius:3mm;z-index:2;}' +
  '.top{display:flex;align-items:center;gap:3.5mm;background:linear-gradient(120deg,' + gradA + ',' + gradB + ');padding:5mm 6mm;}' +
  '.logochip{background:#fff;border-radius:2mm;padding:1.6mm 2.4mm;display:flex;align-items:center;}' +
  '.logochip img{height:9mm;width:auto;display:block;}' +
  '.brandbox{color:#fff;}' +
  '.bn{font-size:13pt;font-weight:700;line-height:1.1;letter-spacing:0.01em;}' +
  '.bt{font-size:6.5pt;letter-spacing:0.1em;text-transform:uppercase;color:rgba(255,255,255,0.85);margin-top:0.6mm;}' +
  '.bar{height:2mm;background:' + accent + ';}' +
  '.mid{flex:1;padding:5mm 6mm 0;}' +
  '.chip{display:inline-block;background:' + brand + ';color:#fff;font-size:7.5pt;font-weight:700;letter-spacing:0.14em;text-transform:uppercase;padding:1.2mm 3mm;border-radius:5mm;}' +
  '.name{font-size:14pt;font-weight:600;line-height:1.22;color:' + ink + ';margin-top:3mm;}' +
  '.usp{list-style:none;margin:4mm 0 0;padding:3mm 3.5mm 2.4mm;background:' + soft + ';border-left:1.2mm solid ' + accent + ';border-radius:0 2mm 2mm 0;}' +
  '.usp li{position:relative;padding-left:4.5mm;font-size:9.5pt;line-height:1.35;color:' + ink + ';margin-bottom:1.6mm;}' +
  '.usp li:last-child{margin-bottom:0;}' +
  '.usp li:before{content:"";position:absolute;left:0;top:1.7mm;width:2.2mm;height:2.2mm;border-radius:50%;background:' + accent + ';}' +
  '.warr{display:inline-flex;align-items:center;gap:1.6mm;margin-top:3.5mm;background:' + accent + ';color:#fff;font-size:8.5pt;font-weight:700;letter-spacing:0.04em;padding:1.5mm 3.5mm;border-radius:6mm;}' +
  '.warr svg{flex-shrink:0;}' +
  '.pricebox{margin:4mm 6mm 0;background:' + brand + ';border-radius:2.5mm;padding:3.5mm 5mm;text-align:right;}' +
  '.is-sale .pricebox{background:' + sale + ';}' +
  '.ord{font-size:9pt;color:rgba(255,255,255,0.75);}' +
  '.ord s{color:#fff;font-weight:600;}' +
  '.price{font-family:"DM Sans",sans-serif;font-size:34pt;font-weight:700;color:#fff;line-height:1.05;letter-spacing:-0.01em;}' +
  '.vat{font-size:7.5pt;color:rgba(255,255,255,0.7);}' +
  '.bot{display:flex;justify-content:space-between;align-items:flex-end;gap:3mm;margin-top:4mm;padding:3mm 6mm 4mm;background:' + soft + ';border-top:0.4mm solid ' + accent + ';}' +
  '.ids{font-size:7.5pt;color:' + ink + ';line-height:1.5;}' +
  '.ids b{color:' + brand + ';}' +
  '.bc{height:13mm;width:38mm;}' +
  '</style></head><body><div class="sheet">' + cells + '</div>' +
  barcodeRunner(38, 1.5) +
  '</body></html>';
}

function buildSmall(items, offX, offY){
  /* Avery L7160 / 3652: 63,5 x 38,1 mm, 3 kolumner x 7 rader = 21 per ark.
     Marginal topp 15,1 mm, vänster 7,2 mm, horisontellt mellanrum 2,5 mm. */
  var cells = items.map(function(r){
    var bc = bcSpec(r);
    return '<div class="lbl"><div class="inner">' +
      '<div class="name">' + esc(fullName(r)) + '</div>' +
      '<div class="mid">' +
        '<div class="sku">' + (r.sku ? 'Art.nr ' + esc(r.sku) : '&nbsp;') + '</div>' +
        '<div class="price">' + kr(r.price) + '</div>' +
      '</div>' +
      '<div class="bc-wrap">' +
        (bc ? '<svg class="bc" data-v="' + esc(bc.v) + '" data-f="' + bc.f + '"></svg><div class="ean">' + esc(bc.label) + '</div>' : '<div class="ean">&nbsp;</div>') +
      '</div>' +
    '</div></div>';
  }).join('');

  return '<!DOCTYPE html><html lang="sv"><head><meta charset="UTF-8"><title>Etiketter 65x38</title><style>' +
  '@import url("https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap");' +
  '@page{size:A4 portrait;margin:0;}' +
  '*{box-sizing:border-box;margin:0;padding:0;}' +
  'body{font-family:"DM Sans",sans-serif;color:#000;background:#fff;-webkit-print-color-adjust:exact;print-color-adjust:exact;}' +
  '.sheet{width:210mm;padding:' + (15.1 + offY) + 'mm 0 0 ' + (7.2 + offX) + 'mm;display:grid;grid-template-columns:repeat(3,63.5mm);column-gap:2.5mm;row-gap:0;}' +
  '.lbl{width:63.5mm;height:38.1mm;padding:1.6mm 2mm;overflow:hidden;}' +
  '.inner{height:100%;display:flex;flex-direction:column;justify-content:space-between;}' +
  '.name{font-size:7pt;font-weight:600;line-height:1.2;max-height:8.5mm;overflow:hidden;}' +
  '.mid{display:flex;justify-content:space-between;align-items:flex-end;gap:2mm;}' +
  '.sku{font-size:6pt;color:#333;}' +
  '.price{font-size:13pt;font-weight:700;line-height:1;white-space:nowrap;}' +
  '.bc-wrap{text-align:center;}' +
  '.bc{height:8mm;width:46mm;}' +
  '.ean{font-size:5.8pt;letter-spacing:0.06em;margin-top:0.2mm;}' +
  '</style></head><body><div class="sheet">' + cells + '</div>' +
  barcodeRunner(26, 1.1) +
  '</body></html>';
}

/* ---- init -------------------------------------------------------------- */
window.DPE = {
  search: search,
  add: add,
  remove: remove,
  setQty: setQty,
  setUsp: setUsp,
  setWarranty: setWarranty,
  toggleUsp: toggleUsp,
  setAllQty: setAllQty,
  clear: clearList,
  loadCollection: loadCollection,
  print: printSheet
};

function init(){
  if(!el('dpe-etiketter')) return;
  D = window.DPE_DATA || D;
  renderList();
  var s = el('dpeSearch');
  if(s) s.addEventListener('keydown', function(e){ if(e.key === 'Enter'){ e.preventDefault(); search(); } });
}

if(document.readyState === 'loading'){
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
document.addEventListener('shopify:section:load', function(e){
  if(e.target && e.target.querySelector && e.target.querySelector('#dpe-etiketter')) init();
});
})();
